<template>
  <div class="content">
    <slot />
  </div>
</template>

<script>
export default {
  components: {}
};
</script>
<style lang="scss" scoped>
.content {
  padding: 0 15px;
}
</style>



// WEBPACK FOOTER //
// src/layouts/Default.vue